export default "__VITE_ASSET__GRtRGCnE__"